import React from 'react';

interface StepDotsProps {
  /** Step atual (0-indexed). */
  step: number;
  total: number;
  className?: string;
}

/**
 * Progress bar segmentada do wizard mobile. Segmentos antes do `step`
 * sao marcados como "done" e o atual como "active" (com leve scale Y).
 *
 * Origem: templates/Login com Google/src/mobile-signup.jsx <StepDots>.
 */
export function StepDots({ step, total, className }: StepDotsProps) {
  const root = ['auth-step-dots', className].filter(Boolean).join(' ');
  return (
    <div
      className={root}
      role="progressbar"
      aria-valuenow={step + 1}
      aria-valuemin={1}
      aria-valuemax={total}
      aria-label={`Passo ${step + 1} de ${total}`}
    >
      {Array.from({ length: total }).map((_, i) => {
        const cls = [
          'auth-step-dot',
          i < step && 'auth-step-dot--done',
          i === step && 'auth-step-dot--active',
        ]
          .filter(Boolean)
          .join(' ');
        return <span key={i} className={cls} />;
      })}
    </div>
  );
}
